import {gql} from '@apollo/client';

import {ActionPlanAdjustmentListFragment} from '#apollo/schema';
import {learningResourceCardFragment} from '#component/partial/LearningResourceCard/LearningResourceCard';

import {checkInCardTestPeriodFragment} from './component/common/CheckInCard';

export const dashboardLabStatusFragment = gql`
  fragment DashboardLabStatusFragment on LabStatus {
    id
    createdAt
    status
  }
`;
export const ageFormattedAgeFragment = gql`
  fragment AgeFormattedAgeFragment on FormattedAge {
    months
    years
  }
`;

export const ageLabResultMetricFragment = gql`
  fragment AgeLabResultMetric on LabResultMetric {
    id
    percentile
    type
  }
`;

export const ageLabAssessmentFragment = gql`
  ${ageFormattedAgeFragment}
  ${ageLabResultMetricFragment}

  fragment AgeLabAssessmentFragment on LabAssessment {
    deltaAge
    formattedBioAge {
      ...AgeFormattedAgeFragment
    }
    formattedChronologicalAge {
      ...AgeFormattedAgeFragment
    }
    formattedDeltaAge {
      ...AgeFormattedAgeFragment
    }
    id
    labResultMetrics {
      ...AgeLabResultMetric
    }
  }
`;

export const dashboardQuery = gql`
  ${ActionPlanAdjustmentListFragment}
  ${checkInCardTestPeriodFragment}
  ${dashboardLabStatusFragment}
  ${learningResourceCardFragment}
  ${ageLabAssessmentFragment}

  query DashboardQuery {
    me {
      ...DashboardUserFragment
    }

    currentTestPeriod {
      ...CheckInCardTestPeriodFragment
    }

    learningResources(input: {context: Dashboard}) {
      ...LearningResourceCardFragment
    }
  }

  fragment DashboardUserFragment on User {
    id
    labSubmissions {
      id
    }
    mostRecentLabSubmission {
      ...DashboardMostRecentLabSubmissionFragment
    }
    mostRecentLabSubmissionWithResults {
      ...MostRecentLabSubmissionWithResultsFragment
    }
    subscription {
      hasActiveSubscription
      hasMembership
      id
    }
    userProfile {
      id
      firstName
    }
    customerAccount {
      id
      subscription {
        id
        status
        hasMembership
        items {
          id
          productId
          variantId
          variantSku
          title
          quantity
          price
        }
        pausedProductVariantIds
      }
    }
  }

  fragment DashboardMostRecentLabSubmissionFragment on LabSubmission {
    id
    registeredDate
    status
    userSurveySubmission {
      id
      surveyAssessment {
        id
        lifestyleScore
        maxLifestyleScore
      }
    }
    labAssessment {
      id
    }
    labStatuses {
      ...DashboardLabStatusFragment
    }
  }

  fragment MostRecentLabSubmissionWithResultsFragment on LabSubmission {
    id
    registeredDate
    status
    userSurveySubmission {
      id
      surveyAssessment {
        ...SurveyAssessmentFragment
      }
    }
    labAssessment {
      ...AgeLabAssessmentFragment
    }
    labRecord {
      ...LabSubmissionRecordFragment
    }
  }

  fragment LabSubmissionRecordFragment on LabSubmissionRecord {
    hasViewedResultStory
    id
  }

  fragment SurveyAssessmentFragment on SurveyAssessment {
    id
    lifestyleScore
    maxLifestyleScore
    categories {
      id
      meetsRequirements
      category {
        id
        title
        key
      }
    }
    selectedActionPlan {
      ...SelectedActionPlanFragment
    }
  }

  fragment SelectedActionPlanFragment on ActionPlan {
    id
    adjustments {
      ...ActionPlanAdjustmentListFragment
    }
  }
`;
